import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import ProductTypeModal from './ProductTypeModal';
import * as Actions from './Actions';
import ProductTypeList from './ProductTypeList';
import IProductType from './IProductType';
import notify from '../../shared/feedback/notifications';
import { handleError } from '../../shared/ErrorCatching';
import { Button } from 'react-bootstrap';
import LogsModal from '../logs/LogsModal';

class ProductTypesPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowModal: false,
            shouldShowLogsModal: false,
            editId: -1,
            logsId: -1
        };

        this.openCreateModal = this.openCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.openLogsModal = this.openLogsModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleLogsModal = this.toggleLogsModal.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list();
    }

    openCreateModal() {
        this.setState({ editId: -1 });
        this.toggleModal();
    }

    openEditModal(id: number) {
        this.setState({ editId: id });
        this.toggleModal();
    }

    openLogsModal(id: number) {
        this.setState({ logsId: id });
        this.toggleLogsModal();
    }

    toggleModal() {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    toggleLogsModal() {
        this.setState({ shouldShowLogsModal: !this.state.shouldShowLogsModal });
    }

    delete(id: number): void {
        this.props.actions
            .delete(id)
            .then(() => {
                notify.success(Translate('product-type-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('product-types/page/title/product-types')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('product-types/page/button-label/create-product-type')}
                </Button>
                {this.state.shouldShowModal && (
                    <ProductTypeModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}

                {this.state.shouldShowLogsModal && (
                    <LogsModal
                        id={this.state.logsId}
                        type="ProductTypeId"
                        shouldShowModal={this.state.shouldShowLogsModal}
                        closeModal={this.toggleLogsModal}
                    />
                )}
                <ProductTypeList
                    items={this.props.productTypes}
                    beginEdit={this.openEditModal}
                    delete={this.delete}
                    showLogs={this.openLogsModal}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        productTypes: state.productTypes.list,
        productType: state.productTypes.edit
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            delete: (id: number) => dispatch(Actions.deleteProductType(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductTypesPage);
